import { useState } from "react";
import { useExchangesMaxLeverage } from "@shared/features/tradingTerminal/common/hooks/misc.ts";
import SignalLeverageWarningModal from "features/tradingTerminal/General/SignalLeverageWarningModal.tsx";

interface useSignalLeverageWarningModalProps {
  setMultiplier: (leverage: number) => void;
}

const useSignalLeverageWarningModal = ({
  setMultiplier,
}: useSignalLeverageWarningModalProps) => {
  const [pendingLeverage, setPendingLeverage] = useState<number | undefined>();
  const { getInvalidLeverageSelectedExchangesData } = useExchangesMaxLeverage();

  const onMultiplierChange = (leverage: number) => {
    const invalidLeverageSelectedExchangesData =
      getInvalidLeverageSelectedExchangesData(leverage);
    if (Object.keys(invalidLeverageSelectedExchangesData).length > 0) {
      setPendingLeverage(leverage);
    } else {
      setMultiplier?.(leverage);
    }
  };

  const leverageWarningModal = (
    <SignalLeverageWarningModal
      pendingLeverage={pendingLeverage}
      setPendingLeverage={setPendingLeverage}
      getInvalidLeverageSelectedExchangesData={
        getInvalidLeverageSelectedExchangesData
      }
      setMultiplier={setMultiplier}
    />
  );

  return {
    onMultiplierChange,
    leverageWarningModal,
  };
};

export default useSignalLeverageWarningModal;
